module.exports = __webpack_public_path__ + "img/arrow_cart.ce072eb4.svg";